import axios from 'axios'
import {
  MessageBox,
  Message,
  Loading
} from 'element-ui'

import router from '../router'

// 全局 loading 用引用计数管理：并发多个带 loading 的请求时，
// 只有第一个创建实例、最后一个响应关闭，避免实例被覆盖后永不关闭（圈圈卡死）
let gb_loading = null
let loading_count = 0
let loading_conf = {
  fullscreen: true,
  background: 'rgba(0, 0, 0, 0.01)'
}

function openLoading () {
  loading_count += 1
  if (loading_count === 1) {
    gb_loading = Loading.service(loading_conf)
  }
}

function closeLoading () {
  if (loading_count <= 0) return
  loading_count -= 1
  if (loading_count === 0 && gb_loading) {
    gb_loading.close()
    gb_loading = null
  }
}
// create an axios instance
const service = axios.create({
  baseURL: 'https://serverapi.173key.cn/api', // url = base url + request url
  // baseURL: 'http://jpbs.com/api', // url = base url + request url
  timeout: 20000 // request timeout
})

// JSON.parse(localStorage.getItem(k))
// request interceptor
service.interceptors.request.use(
  config => {
    // jwt
    config.headers['_pla'] = 'pc';
    try {
      config.headers['token'] = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : '';
    } catch (e) {
      config.headers['token'] = localStorage.getItem('token') || '';
    }
    // 语言从 URL 前缀推导（/en/、/jp/、/tw/、/kor/，无前缀 = 中文），与多语言 URL/预渲染保持一致；
    // 调用方显式传了 lang 头时不覆盖（用于如文章接口非中文语言无数据时回落中文）
    try {
      if (!config.headers['lang']) {
        const m = location.pathname.match(/^\/(en|jp|kor|tw)(\/|$)/)
        config.headers['lang'] = m ? m[1] : 'cn'
      }
    } catch (e) {
      config.headers['lang'] = config.headers['lang'] || 'cn';
    }
    return config
  },
  error => {

    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    closeLoading()
    /** 验证 token */
    if (res.code == 2) {
      Message({
        message: '请先登录',
        type: 'error',
        duration: 3 * 1000
      })

      let curr_url = window.location.href;

      localStorage.setItem('pcwxbkurl', curr_url)

      router.push({ path: '/login', replace: true })
      return Promise.reject(new Error(res.msg || 'Error'))
    }
    /** 业务逻辑未通过 */
    if (res.code == 0) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(new Error(res.msg || 'Error'))
    }

    /***
     * code 等于其他情况..
     */
    return res.data

  },
  error => {
    closeLoading()
    Message({
      message: error,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

// gb_loading = Loading.service(loading_conf);

// 预渲染用：是否还有进行中的带 loading 请求（用于判断页面数据是否已安静）
export function isLoadingPending () {
  return loading_count > 0
}

export function get(url, _data = {}, method = 'get', show_load = true, extraHeaders = null) {
  if (show_load) {
    openLoading();
  }


  let params, data = {}
  if (method == 'get') {
    params = _data
  } else {
    data = _data
  }
  return service({
    url: url,
    method: method,
    params: params,
    data: data,
    headers: extraHeaders || undefined,
  })
}

// export function down(url, _data = {}, method = 'post') {
//   gb_loading = Loading.service(loading_conf);
//   _data.sss = 'pc'
//   let params, data = {}
//   if (method == 'get') {
//     params = _data
//   } else {
//     data = _data
//   }
//   return service({
//     url: url,
//     method: method,
//     params: params,
//     data: data,
//     responseType: 'blob'
//   })
// }

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js